import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min"
import "icheck";
import "jquery-confirm";
import 'select2';
import 'select2/dist/js/i18n/vi';
import {GhtkAuth} from "gmjs";
import oidc from "@/oidc";

/**
 * Resize function without multiple trigger
 *
 * Usage:
 * $(window).smartresize(function(){
 *     // code here
 * });
 */
(function ($, sr) {
  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  var debounce = function (func, threshold, execAsap) {
    var timeout;

    return function debounced() {
      var obj = this, args = arguments;

      function delayed() {
        if (!execAsap) {
          func.apply(obj, args);
        }
        timeout = null;
      }

      if (timeout) {
        clearTimeout(timeout);
      } else if (execAsap) {
        func.apply(obj, args);
      }

      timeout = setTimeout(delayed, threshold || 100);
    };
  };

  // smartresize
  jQuery.fn[sr] = function (fn) {
    return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
  };

})(jQuery, 'smartresize');

const ghtkAuth = new GhtkAuth(oidc);

export default {
  install(Vue) {
    let vue = new Vue();

    ghtkAuth.tokenManager.get('accessToken').then(tokenInfo => {
      const accessToken = tokenInfo ? tokenInfo.accessToken : '';
      $.ajaxSetup({
        headers: {
          "Authorization": `Bearer ${accessToken}`
        },
      });
    });

    $.ajaxSetup({
      beforeSend(jqXHR, settings) {
        NProgress.start();
      },
      complete(jqXHR, textStatus) {
        NProgress.done();
        let status = jqXHR.status;
        if (status !== 200) {
          if (status === 0) {
            // vue.$notify({
            //   verticalAlign: 'bottom',
            //   horizontalAlign: 'right',
            //   type: "danger",
            //   message: 'Lỗi kết nối'
            // });
          } else if (status === 401) {
            vue.$notify({
              verticalAlign: 'bottom',
              horizontalAlign: 'right',
              type: "warning",
              message: 'Hết phiên đăng nhập'
            });
            vue.$router.push("/login");
          } else {
            // vue.$notify({
            //   verticalAlign: 'bottom',
            //   horizontalAlign: 'right',
            //   type: "danger",
            //   message: "Lỗi xảy ra!"
            // });
          }
        }
      }

    });

  }
}